module.exports = __webpack_public_path__ + "static/img/5.cdb90ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20240725/5.jpg
// module id = LvJE
// module chunks = 7